import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7ff8fd44&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=7ff8fd44&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff8fd44",
  null
  
)

export default component.exports